import type * as Constants from './constants';

/**
 * These are all the potential values for the state of a given progress
 * that are returned from the backend
 */
export enum RefreshRevenueProgressStatus {
    COMPLETED = 'COMPLETED',
    OUTDATED = 'OUTDATED',
    UNKNOWN = 'UNKNOWN',
    PENDING = 'PENDING',
}

export interface RevenueProgressResult {
    completedMonths: number;
    refreshRequestedId: string;
    refreshRequestedAt: string;
    status: RefreshRevenueProgressStatus;
    totalMonths: number;
}

export interface FetchingPayload {
    targetId: string;
    targetType: Constants.REVENUE_TARGET_TYPES;
    year: string;
    refresh: boolean;
    firstMonth: string;
    numberOfMonths: string;
    filter: Constants.REVENUE_FILTER | null;
}

export interface ProgressUpdatePayload {
    result: RevenueProgressResult;
    originalPayload: FetchingPayload;
}
